"use client";

import { Grading } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";

import { useOpenAccount } from "@/context/openAccount";
import { useRecaptcha } from "@/context/util/recaptcha";

import StepButtonWrapper from "@/components/wrapper/stepButton";

export default function AcceptButton() {
  const { showV2 } = useRecaptcha();
  const { openAccountUser, setActiveStep } = useOpenAccount();

  function getTooltip() {
    if (!openAccountUser?.termsAccepted) {
      return "Please scroll to the bottom of the terms to continue";
    } else if (showV2) {
      return "Please complete the reCAPTCHA to continue";
    }
    return "Click to accept these terms";
  }

  return (
    <StepButtonWrapper
      button={
        <Tooltip title={getTooltip()}>
          <Button
            onClick={() => setActiveStep((prev) => prev + 1)}
            startIcon={<Grading />}
            sx={{
              alignContent: "flex-end",
              height: 48,
              paddingLeft: "2em",
              paddingRight: "2em",
              width: {
                xs: "100%",
                sm: "auto",
              },
            }}
            variant="contained"
          >
            Accept
          </Button>
        </Tooltip>
      }
    />
  );
}
